<a href="/" [class]="customHrefClass" (window:resize)="onResize()">
    <img class="logo" alt="Logo" *ngIf="!appSession.tenant || !appSession.tenant.logoId" [src]="defaultLogo" />
    <img class="logo-min" alt="Logo" *ngIf="!appSession.tenant || !appSession.tenant.logoId" [src]="defaultLogoMin" />
</a>